import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, DataTable, Card, Thumbnail } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import FormPageActions from '@container/FormPageActions';
import { buildShipHeroURL } from 'utils';
import { ViewMinor } from '@shopify/polaris-icons';

const propTypes = {
  orderSupply: PropTypes.object.isRequired,
  lineItems: PropTypes.array.isRequired,
  cancelURL: PropTypes.string,
  cancelled: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool,
};


class OrderSupplyShow extends Component {
  constructor(props){
    super();
    this.state = {
      cancelled: props.cancelled
    }
  }
  render() {
    const orderSupply = this.props.orderSupply;
    console.log(orderSupply);
    const shipHeroURL = this.props.isAdmin && buildShipHeroURL(orderSupply.ship_hero_po_id);
    return (
      <AppProvider i18n={translations}>
        <div>
          <Page
            fullWidth
            breadcrumbs={[{content: I18n.t("actions.back"), url: '/order_supplies'}]}
            secondaryActions={ !!shipHeroURL ? [
              {
                content: 'Ver PO en ShipHero',
                external: true,
                url: shipHeroURL,
                icon: ViewMinor
              }] : []
            }
          >
            <div className="mb20 flex alignItemsCenter">
              <h1 className="Polaris-DisplayText Polaris-DisplayText--sizeLarge mr10">
                {`ID: ${orderSupply.display_bright_pearl_id}`}
              </h1>
              <span>{ orderSupply.created_at_text }</span>
            </div>
            <Card>
              <DataTable
                columnContentTypes={[
                  'text','text','text','text','text', 'text', 'text'
                ]}
                headings={[
                  "",// I18n.t(`shopify.line_item.image`),
                  I18n.t(`shopify.line_item.vendor`),
                  I18n.t(`shopify.line_item.name`),
                  I18n.t(`shopify.line_item.variant_title`),
                  I18n.t(`shopify.line_item.sku`),
                  I18n.t(`shopify.line_item.quantity`),
                  I18n.t(`shopify.line_item.order_number`),
                ]}
                verticalAlign="middle"
                rows={
                  this.props.lineItems.map( li => [
                    <Thumbnail
                      source={ li.imageSrc }
                    />,
                    li.vendor,
                    li.name,
                    li.variantTitle,
                    li.sku,
                    li.quantity,
                    li.orderNumber
                  ])
                }
              />
            </Card>

            { this.props.isAdmin &&
              <Page>
                <Card title="Supply Logs sent to ShipHero">
                  <DataTable
                    columnContentTypes={[
                      'text','text','text','text','text'
                    ]}
                    headings={[
                      I18n.t(`activerecord.attributes.supply_log.variant_id`),
                      I18n.t(`activerecord.attributes.supply_log.ship_hero_id`),
                      I18n.t(`activerecord.attributes.supply_log.sku`),
                      I18n.t(`activerecord.attributes.supply_log.quantity`),
                      I18n.t(`activerecord.attributes.supply_log.status`),
                    ]}
                    verticalAlign="middle"
                    rows={
                      orderSupply.supply_logs.map( log => [
                        log.display_variant_id,
                        log.ship_hero_id,
                        log.sku,
                        log.quantity,
                        I18n.t(`enum.status.${log.status}`)
                      ])
                    }
                  />
                </Card>
              </Page>
            }

            {/* cancelURL must be present and order shouldn't have been cancelled yet */}
            { (!this.props.cancelled && !!this.props.cancelURL) &&
              <FormPageActions
                deleteText={ I18n.t("actions.cancel") }
                deleteURL={ this.props.cancelURL }
              />
            }

          </Page>
        </div>
      </AppProvider>
    );
  }
}


OrderSupplyShow.propTypes = propTypes;


export default OrderSupplyShow;
